import Anchor from "components/Anchor";
import type { AnchorAdapterProps } from "./Anchor.d";

const AnchorAdapter = ({ blok: { id } }: AnchorAdapterProps) => <Anchor id={id} />;

export default AnchorAdapter;
